"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nbugsMobileV2Utils = require("nbugs-mobile-v2-utils");

var _package = require("../../../package.json");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function createLogger() {
  function onEffect(effect, saga, model, actionType) {
    return (
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _ref,
            type,
            restParams,
            start,
            end,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length <= 0 ? undefined : _args[0], type = _ref.type, restParams = _objectWithoutProperties(_ref, ["type"]);
                start = +new Date();
                _context.next = 4;
                return effect.apply(void 0, _args);

              case 4:
                end = +new Date();
                _context.next = 7;
                return _nbugsMobileV2Utils.Tracker.logger({
                  eventType: 'component-effect',
                  component_name: _package.name,
                  effect_name: actionType,
                  effect_params: JSON.stringify(restParams),
                  effect_time: end - start
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      })
    );
  }

  return {
    onEffect: onEffect
  };
}

var _default = createLogger;
exports.default = _default;